(() => {
  'use strict';
  if (window.UniCollectionSort) { window.UniCollectionSort.init(); return; }
  function init() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid?.hasAttribute('data-uni-collection-sort') || grid.dataset.uniSortReady) return;
    const supported = new Set((grid.dataset.uniCollectionSortOptions || 'manual,created-descending,best-selling,price-ascending,price-descending').split(','));
    const defaultSort = supported.has(grid.dataset.uniCollectionDefaultSort) ? grid.dataset.uniCollectionDefaultSort : 'created-descending';
    grid.dataset.uniSortReady = 'true';
    const feedback = document.querySelector('[data-uni-collection-sort-feedback]');
    const message = feedback.querySelector('[data-uni-collection-sort-message]');
    const retry = feedback.querySelector('[data-uni-collection-sort-retry]');
    const fallback = feedback.querySelector('[data-uni-collection-sort-fallback]');
    const Facets = customElements.get('facet-filters-form');
    let appliedSort = supported.has(grid.dataset.uniCollectionSort) ? grid.dataset.uniCollectionSort : defaultSort;
    let revision = 0, controller, retryParams;
    function paramsFor(value) {
      const params = new URLSearchParams(value || '');
      const requestedSort = params.get('sort_by');
      if (!supported.has(requestedSort)) params.set('sort_by', requestedSort ? defaultSort : appliedSort);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) params.set('preview_theme_id', preview);
      params.delete('section_id');
      return params;
    }
    function sortedURL(params) {
      const url = location.pathname + '?' + params.toString();
      return window.UniThemePreview?.url(url) || url;
    }
    function busy(params) {
      grid.dataset.uniSortPending = 'true';
      grid.setAttribute('aria-busy', 'true');
      grid.inert = true;
      feedback.hidden = false;
      retry.hidden = true;
      message.textContent = grid.dataset.uniSortLoading;
      fallback.href = sortedURL(params);
    }
    function failed() {
      feedback.hidden = false;
      retry.hidden = false;
      message.textContent = grid.dataset.uniSortError;
      grid.removeAttribute('aria-busy');
      grid.inert = false;
      document.querySelectorAll('.loading__spinner').forEach(node => node.classList.add('hidden'));
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(node => node.classList.remove('loading'));
      Facets?.toggleActiveFacets(false);
    }
    if (!Facets) {
      const params = paramsFor(location.search);
      if (grid.dataset.uniSortPending === 'true') {
        params.delete('page'); busy(params); failed();
        retry.addEventListener('click', () => location.assign(sortedURL(params)));
      }
      return;
    }
    Facets.renderPage = async (value, event, updateURLHash = true) => {
      const params = paramsFor(value);
      if (event?.target?.name === 'sort_by') params.delete('page');
      const searchParams = params.toString();
      const id = ++revision;
      controller?.abort();
      controller = new AbortController();
      const currentController = controller;
      retryParams = searchParams;
      Facets.searchParamsPrev = searchParams;
      busy(params);
      if (updateURLHash) Facets.updateURLHash(searchParams);
      const timeout = setTimeout(() => currentController.abort(), 15000);
      try {
        const section = document.getElementById('product-grid')?.dataset.id;
        if (!section) throw new Error('Missing collection section');
        const url = new URL(location.pathname, location.origin);
        url.search = searchParams;
        url.searchParams.set('section_id', section);
        const request = url.pathname + url.search;
        const response = await fetch(window.UniThemePreview?.url(request) || request, { signal: currentController.signal, credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Collection request failed');
        const html = await response.text();
        if (id !== revision) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const returnedGrid = parsed.getElementById('ProductGridContainer');
        if (!returnedGrid || returnedGrid.dataset.uniCollectionSort !== params.get('sort_by')) throw new Error('Unexpected collection sort');
        if (document.getElementById('FacetFiltersFormMobile')) Facets.renderFilters(html, event);
        Facets.renderProductGridContainer(html);
        if (document.getElementById('ProductCount') && parsed.getElementById('ProductCount')) Facets.renderProductCount(html);
        appliedSort = returnedGrid.dataset.uniCollectionSort;
        grid.dataset.uniCollectionSort = appliedSort;
        grid.dataset.uniSortPending = 'false';
        document.querySelectorAll('facet-filters-form [name="sort_by"]').forEach(select => { select.value = appliedSort; });
        window.UniMobile?.initCardForms?.();
        feedback.hidden = true;
        retry.hidden = true;
        if (!updateURLHash) history.replaceState({ ...history.state, searchParams }, '', sortedURL(params));
      } catch (error) {
        if (id === revision) failed();
      } finally {
        clearTimeout(timeout);
        if (id === revision) { grid.removeAttribute('aria-busy'); grid.inert = false; }
      }
    };
    retry.addEventListener('click', () => Facets.renderPage(retryParams, null, false));
    const initialParams = paramsFor(location.search);
    // Canonical history preserves the actual supported server order without another request.
    if (grid.dataset.uniSortPending !== 'true') {
      const searchParams = initialParams.toString();
      Facets.searchParamsInitial = Facets.searchParamsPrev = searchParams;
      history.replaceState({ ...history.state, searchParams }, '', sortedURL(initialParams));
    } else {
      initialParams.delete('page');
      Facets.searchParamsInitial = initialParams.toString();
      Facets.renderPage(initialParams.toString(), null, false);
    }
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(grid)) { revision++; controller?.abort(); }
    });
  }
  window.UniCollectionSort = { init };
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
